const mutations = {
  //自助商标复审
  changeReview(state, payload) {
    // console.log(payload);
    state.reviewInfo = payload;
  },
  changeProductList(state, payload) {
    // console.log(state);
    // console.log(payload);
    state.productList = payload;
  },
  changeAppli(state, payload) {
    state.applicantInfo = payload;
  },
  changeEvi(state, payload) {
    // console.log(state);
    // console.log(payload);
    state.evidenceMaterial = payload;
  },


  //专业商标复审
  changePFReview(state, payload) {
    // console.log(state);
    // console.log(payload);
    state.PFreviewInfo = payload;
  },
  changePFProductList(state, payload) {
    // console.log(state);
    // console.log(payload);
    state.PFproductList = payload;
  },
  changePFcontactInfo(state, payload) {
    // console.log(state);
    // console.log(payload);
    state.PFcontactInfo = payload;
  },

  //订单信息
  changeOrderInfo(state, payload) {
    state.orderInfo = payload;
  },
};

export default mutations;
